<div class="input-group">
    <p-button severity="danger" outlined="true" (onClick)="minus();"> - </p-button>
    <input type="number" name="item" class="form-control plus-minus-button"
        [formControl]="formControl" [formlyAttributes]="field" />
    <p-button  severity="primary" outlined="true" (onClick)="plus();">+</p-button>
    <!-- {{model | json}} -->
</div>